import { BPanel, Breadcrumb } from '@sketchpixy/rubix';
import { Link } from 'react-router';
import React from 'react';

import { AlertSchema, Alerts } from '../../collections/alerts/alerts';
import MgfForm from '../common/mgfForm';

export default class AlerteAddPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}	

	handleSubmit(doc) {
		this.context.router.push('/alerts');
	}

	render() {
		return (
			<div>
				<Breadcrumb>
					<Breadcrumb.Item>
						<Link to="/alerts">Alertes</Link>
					</Breadcrumb.Item>
					<Breadcrumb.Item href="#" active>
						Ajouter une alerte
					</Breadcrumb.Item>
				</Breadcrumb>
				<BPanel header="Ajouter une alerte">
					<MgfForm schema={AlertSchema} collection={Alerts} onSubmit={this.handleSubmit.bind(this)} />
				</BPanel>
			</div>
		);
	}
}

AlerteAddPage.contextTypes = {
	router: React.PropTypes.object.isRequired
};



/** WEBPACK FOOTER **
 ** ./src/universal/components/alerts/AlertAdd.page.js
 **/